import { apiClient, occmClient, setAccessToken } from "utils/clients";
import _ from "lodash";
import { handleAIDEToken } from "utils/darkSite";
import { logUserActions } from "utils/auth/common";
import { setUserId } from "utils/localstorage";

const loginSuccess = (dispatch, payload, aidpLoginToken, userId) => {
    dispatch({
        type: 'AUTH:REFRESH-SSO-SUCCESS',
        payload: payload
    });
    setAccessToken(aidpLoginToken);
    setUserId({ userId });
    logUserActions("LOGIN_USER", userId);
};

function getCookieStr(cookieName) {
    const searchKey = cookieName + "=";
    const cookieItem = _.find(
        _.map(document.cookie.split(';'), _.trim),
        item => _.startsWith(item, searchKey)
    );

    return cookieItem ? cookieItem.substring(searchKey.length) : null;
}

export default ({ dispatch, getState }) => next => async (action) => {
    const { type } = action;

    if (type === 'AUTH:INITIALIZE') {
        dispatch({
            type: "APP:AIDP-LOGIN-PROGRESS"
        });
        const aidpLoginToken = sessionStorage.getItem('ot');
        if (aidpLoginToken) {
            const tokenData = handleAIDEToken(aidpLoginToken);
            const userId = encodeURIComponent(tokenData?.sub);
            const payload = {
                accessToken: aidpLoginToken,
                "idTokenPayload": { ...tokenData, sub: userId },
                "scope": "",
                "paramsForUI": {}
            }
            const date = new Date();
            if (Math.floor(date.getTime() / 1000) > tokenData.tokenData.payload?.exp) {
                dispatch({
                    type: 'AUTH:LOGOUT'
                });
            } else {
                const headers = {
                    'Authorization': `Bearer ${aidpLoginToken}`
                };
                let noncompliant = 'NO-LICENSE';
                try {
                    const response = await occmClient.get(process.env.REACT_APP_AIDE_LICENSE_API_URL + '?fields=*&name=ai_data_engine', { headers });
                    const license = _.head(_.get(response, 'data.records'));
                    if (_.get(license, 'state', '') === 'compliant' || _.get(license, 'licenses[0].serial_number')) {
                        noncompliant = null;
                        if (license && _.get(license, 'state', '') === 'noncompliant') {
                            const disableSize = _.get(license, 'licenses[0].capacity.disabled_size', 0);
                            const maxSize = _.get(license, 'licenses[0].capacity.maximum_size', 0);
                            if(disableSize >= maxSize) {
                                noncompliant = 'EXPIRED-LICENSE';
                            }
                        }
                    }
                } catch (error) {
                    console.error('Error fetching licenses:', error);
                }
                loginSuccess(dispatch, noncompliant ? { ...payload, status: noncompliant } : { ...payload, status: "SUCCESS" }, aidpLoginToken, userId);
            }
        } else {
            dispatch({
                type: 'AUTH:LOGOUT'
            });
        }
    } else if (type === "AUTH:LOGOUT") {
        sessionStorage.removeItem('ot');
        const userId = _.get(getState(), "auth.userId");
        logUserActions("LOGOUT_USER", userId);
        // Call /security/logout API to invalidate the session
        try {
            const headers = {
                'DOT-CSRF-Token': getCookieStr('DOT-CSRF')
            };
            await apiClient.post(process.env.REACT_APP_AIDE_LOGOUT_API_URL, { headers });
        } catch (error) {
            console.log('Could not invalidate session:', error);
        }
        window.location.replace('/oidc/callback?logout=');
    }

    return next(action);
}